<template>
     <div v-show="!hasParent" class="sc-price-info" :class="{ fadeInRight: show }">
        <div class="sc-price">
          ${{
            parseInt(price)
          }}<span class="small">.{{ price.split(".")[1] }}</span>
          <span v-if="vat > 0" class="sc-price-info-vat">+${{ vat }} VAT</span>
        </div>
      </div>
</template>

<script>
export default {
    props: {
        price: {
            type: [String, Number],
            default: "0.00"
        },
        vat: {
            type: [String, Number],
            default: "0.00"
        },
        hasParent: {
            type: Boolean,
            default: false
        },
        show: {
            type: [Boolean, Number],
            default: false
        }
    },
}
</script>


// WEBPACK FOOTER //
// PriceComponent.vue?143c9931